import {
    DataObjectIdAttributeName,
    DataObjectKeyAttributeName,
    DataObjectTypeAttributeName,
} from 'shared/content_editable/shared';

const EmbedTagPattern =
    /\{\{(mention|plot|file):([0-9a-fA-F]{8}-(?:[0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12})\}\}/g;

/**
 * Replaces {{DataObjectType:UUID}} tokens with inline HTML spans that useTagPortals
 * can later attach React portals to.
 * @param text The input text containing DataObjectType tokens.
 * @returns The processed text with DataObjectType tokens replaced by HTML spans.
 */
export function preprocessEmbeds(text: string): string {
    let counter = 0;
    return text.replace(EmbedTagPattern, (_: string, type: string, id: string) => {
        // eslint-disable-next-line no-plusplus
        const key = `${id}-${counter++}`;
        return (
            `<span ` +
            `${DataObjectTypeAttributeName}="${type}" ` +
            `${DataObjectKeyAttributeName}="${key}" ` +
            `${DataObjectIdAttributeName}="${id}"` +
            `></span>`
        );
    });
}
